import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { z } from 'zod'
import { axiosInstance } from '../axios-instance'
import {
  createPropertyShape,
  propertyFilterShape,
  propertyInstanceFilterShape,
  propertyPriceInstanceShape,
  propertyShape,
  sireCityShape,
} from './models'

const listSireCitiesCall = createCustomServiceCall({
  outputShape: { cities: z.array(z.object(sireCityShape)) },
  cb: async ({ client, slashEndingBaseUri, utils: { fromApi } }) => {
    const response = await client.get(`${slashEndingBaseUri}sire-cities/`)
    return fromApi(response.data)
  },
})

const syncCalendarsCall = createCustomServiceCall({
  inputShape: z.string(),
  outputShape: z.void(),
  cb: async ({ client, slashEndingBaseUri, input }) => {
    await client.post(`${slashEndingBaseUri}${input}/sync-calendars/`)
  },
})

const regenerateCalendarTokenCall = createCustomServiceCall({
  inputShape: z.string(),
  outputShape: {
    calendarToken: z.string(),
    calendarFeedUrl: z.string(),
  },
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi } }) => {
    const response = await client.post(`${slashEndingBaseUri}${input}/regenerate-calendar-token/`)
    return fromApi(response.data)
  },
})

const duplicateCall = createCustomServiceCall({
  inputShape: { id: z.string(), name: z.string() },
  outputShape: propertyShape,
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi, toApi } }) => {
    const { id, ...body } = toApi(input)
    const response = await client.post(`${slashEndingBaseUri}${id}/duplicate/`, body)
    return fromApi(response.data)
  },
})

export const propertyApi = createApi({
  baseUri: '/properties/',
  client: axiosInstance,
  models: {
    entity: propertyShape,
    create: createPropertyShape,
    extraFilters: propertyFilterShape,
  },
  customCalls: {
    regenerateCalendarToken: regenerateCalendarTokenCall,
    syncCalendars: syncCalendarsCall,
    listSireCities: listSireCitiesCall,
    duplicate: duplicateCall,
  },
})

export const propertyPIApi = createApi({
  baseUri: '/properties/price-instances/',
  client: axiosInstance,
  models: {
    entity: propertyPriceInstanceShape,
    extraFilters: propertyInstanceFilterShape,
  },
})
